"use client";

import { useEffect } from "react";
import { reportBrowserFailure } from "@/lib/browser-telemetry";
import { Button } from "@/components/ui/button";
import { PermissionDenied } from "@/components/PermissionDenied";
import { isConvexPermissionDenied } from "@/lib/convex-errors";

export default function Error({ error, reset }) {
  useEffect(() => {
    if (!isConvexPermissionDenied(error)) {
      reportBrowserFailure(error, "react.route-boundary");
    }
  }, [error]);

  if (isConvexPermissionDenied(error)) {
    return <PermissionDenied />;
  }

  return (
    <div className="flex min-h-[40vh] flex-col items-center justify-center gap-4 p-8">
      <h2 className="text-lg font-semibold">Something went wrong</h2>
      <Button type="button" onClick={() => reset()}>
        Try again
      </Button>
    </div>
  );
}
